import { APP_STATUSES } from "utils/AppStatusContext"
import { useSearchParams } from "utils/customHooks"

export const PARAM_NAME = "from"

export function useFrom() {
    const searchParams = useSearchParams()
    return (searchParams.get(PARAM_NAME) ?? undefined) as APP_STATUSES | undefined
}
